import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as rename from '../../../../target/assets-i18n-rename.json';

// CAPP-3477 => SMALL REFACTORING
export class MultipleFileTranslateHttpLoader implements TranslateLoader {
  private readonly renameMap: Record<string, string> = rename as Record<string, string>;

  constructor(
    private http: HttpClient,
    public resources: { prefix: string; suffix: string; renameIndicator: boolean }[] = [{ prefix: '/assets/i18n/', suffix: '.json', renameIndicator: true }]
  ) {}

  public getTranslation(lang: string): Observable<TranslationObject> {
    return forkJoin(
      this.resources.map((config) => {
        const orig = `${lang}${config.suffix}`;
        // FIX: Access the renameMap directly without ['default'].
        // => const r: string = config.renameIndicator ? rename['default'][orig] : orig;
        const r: string = config.renameIndicator ? this.renameMap[orig] : orig;

        return this.http.get(`${config.prefix}${r}`).pipe(catchError((err) => of(`Error loading ${config.prefix}${lang}${config.suffix} : ${err.message}`)));
      })
    ).pipe(
      map((response) => {
        return response.reduce((a, b) => {
          if (typeof a === 'string' && typeof b === 'string') {
            console.error(a);
            console.error(b);
            return {};
          } else if (typeof a === 'string') {
            console.error(a);
            return b;
          } else if (typeof b === 'string') {
            console.error(b);
            return a;
          } else {
            return Object.assign(a, b);
          }
        }) as TranslationObject;
      })
    );
  }
}
